

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  // private apiUrl = 'http://localhost:5001/api/users';
  // private apiUrl = 'https://wooffertechnologies-qa.chetu.com/api/users';
  private apiUrl = 'https://uat.wooffertechnologies.com/backend/api/users'
    //  private apiUrl = 'https://wooffertechnologies.com/backend/api/users';

  constructor(private http: HttpClient) { }

  deleteAccount(formData: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/deleteUserWithCredentials`, formData, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    });
  }
}
